import { render, staticRenderFns } from "./Gmail.vue?vue&type=template&id=c10fc77a&scoped=true"
import script from "./Gmail.vue?vue&type=script&lang=js"
export * from "./Gmail.vue?vue&type=script&lang=js"
import style0 from "./Gmail.vue?vue&type=style&index=0&id=c10fc77a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10fc77a",
  null
  
)

export default component.exports